import { MutationTree } from 'vuex';
import { CourseLocationState } from './types';
import { CourseLocation } from '@/shared/model/courseLocation';

export const mutations: MutationTree<CourseLocationState> = {
  setCourseLocations(state, payload: CourseLocation[]) {
    state.courseLocations = payload;
  },
};
